import React, { Component } from 'react';
import { MsalProvider, withMsal, MsalAuthenticationTemplate } from "@azure/msal-react";
import { PublicClientApplication, InteractionType } from "@azure/msal-browser";
import BreadCrumbComponent from '../../bread-crumb/BreadCrumbComponent';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { reactPlugin, appInsights } from '../../../AppInsights';
import { IACLService } from '../IACLService';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { InputSwitch } from 'primereact/inputswitch';
import Spinner from "../../Spinner";
import AlertMessage from "../../alertmessage/AlertMessage"
import { Dropdown } from 'primereact/dropdown';
import { MessageSeverity, FilterMatchMode, FilterOperator } from 'primereact/api';
import * as Yup from 'yup';

//HDO-5469 - PI 2024 Q3 - Integrate IACL UI features into the Monitoring tool
class ApplicationComponent extends Component {
    constructor() {
        super();
        this.WrappedApplicationComponent = React.createRef();
        this._isMounted = false;
        this.state = {
            pageErrorMessage: '',
            pageSuccessMessage: '',
            caGroupNameList: [],
            applicationList: [],
            application: {
                Id: 0,
                ApplicationName: null,
                CagroupNameId: null,
                CaGroupName: null,
                EmailGroup: null,
                ManagerContact: null,
                ManagerPhone: null,
                SecondaryContact: null,
                TertiaryContact: null,
                IsActive: false
            },
            applicationAuditLogs: [],
            hideSpinner: false,
            showpagination: false,
            editApplicationDialogBoxVisible: false,
            createApplicationDialogBoxVisible: false,
            confirmDeleteApplicationDialogBoxVisible: false,
            applicationAuditLogDialogBoxVisible: false,
            confirmDeleteVisible: false,
            dt: React.createRef(),
            filters: {
                'global': { value: null, matchMode: FilterMatchMode.CONTAINS }
            },
            globalFilterValue: '',
        }
        this.IACLService = new IACLService();
    }

    componentDidMount() {
        this._isMounted = true;
        this.getAllApplication();
    }

    getAllApplication = () => {
        this.setState({ hideSpinner: false, pageSuccessMessage: '', pageErrorMessage: '' });
        this.IACLService.getAllApplication(false, this.props.msalContext).then(
            (d) => {
                if (d.status === 403) {
                    this.setState({ pageErrorMessage: 'You do not have permission to view this page.', hideSpinner: true });
                } else {
                    if (this._isMounted) {
                        d.body.map((item) => {

                        })
                        this.setState({ applicationList: d.body, hideSpinner: true, pageSuccessMessage: '', pageErrorMessage: '' });
                        if (this.state.applicationList.length > 10) {
                            this.setState({ showpagination: true })
                        }
                    }
                }
            }
        ).catch(e => {
            console.log(e)
        });
    }

    getApplicationOpsAuditLog = (rowData) => {
        this.setState({ application: { ...rowData }, hideSpinner: false, pageSuccessMessage: '', pageErrorMessage: '' });
        this.IACLService.getApplicationOpsAuditLog(rowData.Id, this.props.msalContext).then(
            (d) => {
                if (d.status === 403) {
                    this.setState({ pageErrorMessage: 'You do not have permission to view this page.', hideSpinner: true });
                } else {
                    if (this._isMounted) {
                        this.setState({ applicationAuditLogs: d.body, hideSpinner: true, applicationAuditLogDialogBoxVisible: true, pageSuccessMessage: '', pageErrorMessage: '' });
                        if (this.state.applicationAuditLogs.length > 10) {
                            this.setState({ showpagination: true })
                        }
                    }
                }
            }
        ).catch(e => {
            console.log(e)
        });
    }

    getAllCaGroupName = () => {
        this.setState({ caGroupNameList: [], hideSpinner: false, pageSuccessMessage: '', pageErrorMessage: '' });
        this.IACLService.getAllCaGroupName(true, this.props.msalContext).then(
            (d) => {
                if (d.status === 403) {
                    this.setState({ pageErrorMessage: 'You do not have permission to view this page.', hideSpinner: true });
                } else {
                    if (this._isMounted) {
                        d.body.map((item) => (this.state.caGroupNameList.push({ label: item.CAGroupName, value: item.Id })));
                        this.setState({ pageErrorMessage: null, pageSuccessMessage: null, hideSpinner: true });
                    }
                }
            }
        ).catch(e => {
            console.log(e)
        });
    }

    editApplication = (rowData) => {
        return (
            <React.Fragment>
                <Button icon="pi pi-book" className="p-button-rounded p-button-outlined" tooltip="Logs" tooltipOptions={{ position: 'top' }} onClick={(e) => this.getApplicationOpsAuditLog(rowData)} />
                <Button icon="pi pi-pencil" className="p-button-rounded p-button-primary p-mr-2" tooltip="Edit" tooltipOptions={{ position: 'top' }} onClick={() => this.showEditApplicationDialog(rowData)} />
                <Button icon="pi pi-trash" className="p-button-rounded p-button-danger" tooltip="Delete" tooltipOptions={{ position: 'top' }} onClick={e => this.setState({ confirmDeleteApplicationDialogBoxVisible: true, pageErrorMessage: null, pageSuccessMessage: null, application: { ...rowData } })} />
            </React.Fragment>
        );
    }

    showEditApplicationDialog = (rowData) => {
        this.setState({ application: { ...rowData }, editApplicationDialogBoxVisible: true, pageSuccessMessage: '', pageErrorMessage: '' })
        this.getAllCaGroupName();
    }

    showApplicationDialogBoxForCreate = () => {
        this.setState({ createApplicationDialogBoxVisible: true, pageSuccessMessage: '', pageErrorMessage: '' })
        this.clearRowSelection();
        this.getAllCaGroupName();
    }

    clearRowSelection() {
        this.setState({
            application: {
                Id: 0,
                ApplicationName: null,
                CagroupNameId: null,
                CaGroupName: null,
                EmailGroup: null,
                ManagerContact: null,
                ManagerPhone: null,
                SecondaryContact: null,
                TertiaryContact: null,
                IsActive: false
            },
        })
    }

    handleInputChange = (event) => {
        this.setState({
            application: {
                ...this.state.application, //using spread operator to initialize object with existing props
                [event.target.name]: event.target.value
            },
            pageErrorMessage: null
        });
    }

    validateApplicationDialogFormField = async (application, onSave = false, isCreate = false) => {
        if (onSave || isCreate) {
            try {
                let applcationSchema = Yup.object({
                    ApplicationName: Yup.string().required("Application name is required.")
                        .max(200, "Application name cannot be more than 200 characters.")
                        .matches(/^[^'"]*$/, "Application name should not contain single (') or double (\") quotes."),
                    EmailGroup: Yup.string().nullable()
                        .max(200, "Email group cannot be more than 200 characters.")
                        .matches(/^[^'"]*$/, "Email group should not contain single (') or double (\") quotes."),
                    ManagerContact: Yup.string().nullable()
                        .max(200, "Manager contact cannot be more than 200 characters.")
                        .matches(/^[^'"]*$/, "Manager contact should not contain single (') or double (\") quotes."),
                    ManagerPhone: Yup.string().nullable()
                        .max(200, "Manager phone cannot be more than 200 characters.")
                        .matches(/^[^'"]*$/, "Manager phone should not contain single (') or double (\") quotes."),
                    SecondaryContact: Yup.string().nullable()
                        .max(200, "Secondary contact cannot be more than 200 characters.")
                        .matches(/^[^'"]*$/, "Secondary contact should not contain single (') or double (\") quotes."),
                    TertiaryContact: Yup.string().nullable()
                        .max(200, "Tertiary contact cannot be more than 200 characters.")
                        .matches(/^[^'"]*$/, "Tertiary contact should not contain single (') or double (\") quotes.")
                });
                await applcationSchema.validate(application, { abortEarly: false })

                this.setState({ pageErrorMessage: '' });
                this.IsApplicationExists(isCreate);
            }
            catch (error) {
                this.setState({ pageErrorMessage: error.inner[0].message });
            }
        }
    }

    IsApplicationExists(isCreate = false) {
        this.setState({ hideSpinner: false, pageSuccessMessage: '', pageErrorMessage: '' })
        this.IACLService.IsApplicationExists(this.state.application.ApplicationName, this.state.application.Id, this.props.msalContext).then(
            (d) => {
                if (d.status === 403) {
                    this.setState({ pageErrorMessage: 'You do not have permission to view this page.', hideSpinner: true });
                } else {
                    if (d.status === 200 && d.body) {
                        this.setState({ pageErrorMessage: 'The application name provided already exists. Please use a different one.', hideSpinner: true });
                    }
                    else {
                        if (isCreate)
                            this.createApplication();
                        else
                            this.updateApplication();
                    }
                }
            }
        ).catch(e => {
            console.log(e)
        });
    }

    createApplication() {
        let body = JSON.stringify(this.state.application);
        this.IACLService.createApplication(body, this.props.msalContext).then(
            (d) => {
                if (d.status === 403) {
                    this.setState({ pageErrorMessage: 'You do not have permission to view this page.', hideSpinner: true });
                } else {
                    if (this._isMounted && d.status === 200) {
                        this.getAllApplication();
                        this.setState({ pageSuccessMessage: 'Application name created successfully', createApplicationDialogBoxVisible: false, hideSpinner: true });
                    }
                }
            }
        ).catch(e => {
            console.log(e)
        });
    }

    updateApplication() {
        let body = JSON.stringify(this.state.application);
        this.IACLService.updateApplication(this.state.application.Id, body, this.props.msalContext).then(
            (d) => {
                if (d.status === 403) {
                    this.setState({ pageErrorMessage: 'You do not have permission to view this page.' });
                } else {
                    if (this._isMounted && d.status === 200) {
                        this.getAllApplication();
                        this.setState({ pageSuccessMessage: 'Changes saved successfully.', editApplicationDialogBoxVisible: false, hideSpinner: true });
                    }
                }
            }
        ).catch(e => {
            console.log(e)
        });
    }

    saveFooter = (
        <div>
            <Button label='Save' onClick={() => this.validateApplicationDialogFormField(this.state.application, true)} />
            <Button label='Cancel' onClick={e => this.setState({ editApplicationDialogBoxVisible: false, pageErrorMessage: null })} className='p-button-secondary' />
        </div>
    );

    createFooter = (
        <div>
            <Button label='Create' onClick={() => this.validateApplicationDialogFormField(this.state.application, true, true)} />
            <Button label='Cancel' onClick={e => this.setState({ createApplicationDialogBoxVisible: false, pageErrorMessage: null })} className='p-button-secondary' />
        </div>
    );

    deleteApplication() {
        this.setState({ pageErrorMessage: null, pageSuccessMessage: null, hideSpinner: false })
        this.IACLService.deleteApplication(this.state.application.Id, this.props.msalContext).then(
            (d) => {
                if (d.status === 403) {
                    this.setState({ pageErrorMessage: 'You do not have permission to perform this operation.', confirmDeleteApplicationDialogBoxVisible: false, hideSpinner: true });
                } else if (d.status === 200 && d.body) {
                    this.setState({ pageSuccessMessage: 'Application name deleted successfully.', confirmDeleteApplicationDialogBoxVisible: false, hideSpinner: true });
                    this.getAllApplication();
                } else if (d.status === 500 && d.body) {
                    this.setState({ pageErrorMessage: d.body.error, confirmDeleteApplicationDialogBoxVisible: false, hideSpinner: true });
                } else {
                    this.setState({ pageErrorMessage: 'Something went wrong', confirmDeleteApplicationDialogBoxVisible: false, hideSpinner: true });
                }
            }
        ).catch(e => {
            console.log(e)
        });
    }

    confirmDeleteFooter = (
        <div>
            <Button label='Ok' onClick={() => this.deleteApplication()} />
            <Button label='Cancel' onClick={e => this.setState({ confirmDeleteApplicationDialogBoxVisible: false })}
                className='p-button-secondary' />
        </div>
    );

    onGlobalFilterChange = (event, filtersKey) => {
        this.setState({ pageErrorMessage: null, pageSuccessMessage: null })

        const value = event.target.value;
        let filters = { ...this.state[filtersKey] };
        filters['global'].value = value;

        this.setState({ [`${filtersKey}`]: filters });
    }

    globalSearchFilter = (filtersKey) => {
        return (

            <div>
                <div className="flex justify-content-between" >
                    <Button type="button" icon="pi pi-filter-slash" label="Clear" className="p-button-outlined" onClick={this.clearDataTableFilters} />
                    <span className="p-input-icon-left">
                        <i className="pi pi-search"></i>
                        <InputText type="search" value={this.state[`${filtersKey}`]['global'].value || ''} onChange={(e) => this.onGlobalFilterChange(e, filtersKey)} placeholder="Global Search" size="100" />
                    </span>
                    <span>
                        <Button tooltip='Refresh' tooltipOptions={{ position: 'top' }} onClick={this.getAllApplication} icon="pi pi-refresh" />
                    </span>
                </div>
            </div>
        )
    }

    clearDataTableFilters = () => {
        this.setState({
            pageErrorMessage: null,
            pageSuccessMessage: null,
            pageErrorMessage: null,
            filters: {
                'global': { value: null, matchMode: FilterMatchMode.CONTAINS }
            },
            globalFilterValue: '',

        })
        sessionStorage.clear();
    }

    booleanChecker = (rowData) => {
        if (rowData.IsActive) {
            return <span className='masterdata-status-badge status-active'>ACTIVE</span>;
        }
        else {
            return <span className='masterdata-status-badge status-inactive'>INACTIVE</span>;
        }
    };

    onStatusSwitchChange = (e) => {
        this.setState({ application: { ...this.state.application, IsActive: e.value }, pageErrorMessage: null, pageSuccessMessage: null })
    }

    showAlertMessage = (severity, alertMsg) => {
        this.alertMsg.showAlert(severity, alertMsg);
    }

    render() {
        return (
            <MsalAuthenticationTemplate interactionType={InteractionType.Redirect}>
                <div className="applicationContainer">
                    <BreadCrumbComponent {...this.props} />

                    <AlertMessage ref={instance => { this.alertMsg = instance }} />
                    {this.state.pageErrorMessage ? this.showAlertMessage(MessageSeverity.ERROR, this.state.pageErrorMessage) : <></>}
                    {this.state.pageSuccessMessage ? this.showAlertMessage(MessageSeverity.SUCCESS, this.state.pageSuccessMessage) : <></>}

                    <div hidden={this.state.hideSpinner}>
                        <Spinner />
                    </div>

                    <div>
                        <div className='flex justify-content-between' style={{ marginBottom: '10px' }}>
                            <div className="page-header-title">APPLICATION TEAMS</div>
                            <Button label='' icon='pi pi-plus' tooltip='Create Application' tooltipOptions={{ position: 'left' }} onClick={this.showApplicationDialogBoxForCreate} />
                        </div>

                        <DataTable ref={(el) => this.dt = el} value={this.state.applicationList}
                            selectionMode="single"
                            filters={this.state.filters}
                            filterDisplay="menu"
                            responsiveLayout="scroll"
                            header={this.globalSearchFilter('filters')}
                            paginator={this.state.showpagination}
                            rows={10}
                            rowsPerPageOptions={[10, 20, 50, 100]}
                            emptyMessage="No Records found."
                            showGridlines={true}
                            onFilter={(e) => this.setState({ filters: e.filters })}
                            stateStorage="session" stateKey="dt-application-session"
                        >
                            <Column field="ApplicationName" header="Application Name" style={{ textAlign: 'left' }} />
                            <Column field="CaGroupName" header="CA Group Name" style={{ textAlign: 'left' }} />
                            <Column field="EmailGroup" header="Email Group" style={{ textAlign: 'left' }} />
                            <Column field="ManagerContact" header="Manager Contact" style={{ textAlign: 'left' }} />
                            <Column field="ManagerPhone" header="Manager Phone" style={{ textAlign: 'left' }} />
                            <Column field="SecondaryContact" header="Secondary Contact" style={{ textAlign: 'left' }} />
                            <Column field="TertiaryContact" header="Tertiary Contact" style={{ textAlign: 'left' }} />
                            <Column field="Status" header="Status" style={{ textAlign: 'left' }} body={this.booleanChecker} />
                            <Column field="edit" header="Action" body={this.editApplication} style={{ whiteSpace: 'nowrap', width: '150px', textAlign: 'center' }} alignHeader='center' />
                        </DataTable>
                    </div>

                    <Dialog header='Edit Application team' footer={this.saveFooter}
                        visible={this.state.editApplicationDialogBoxVisible} width='600px' modal={true}
                        onHide={e => this.setState({ editApplicationDialogBoxVisible: false, pageErrorMessage: null })} maximizable={false}>
                        <div>
                            {this.state.pageErrorMessage ? this.showAlertMessage(MessageSeverity.ERROR, this.state.pageErrorMessage) : <></>}
                            <table style={{ width: '600px' }}>
                                <tr>
                                    <td>
                                        <label><b>Enable</b></label>
                                        <InputSwitch checked={this.state.application.IsActive} onChange={this.onStatusSwitchChange}
                                            tooltip={this.state.application.IsActive ? 'YES' : 'NO'} />
                                    </td>
                                    <td>
                                        <label><b>Manager Contact</b></label>
                                        <InputText type='text' name='ManagerContact' value={this.state.application.ManagerContact || ''}
                                            onChange={this.handleInputChange} />
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <label className='required-field'><b>Application Name</b></label>
                                        <InputText type='text' name='ApplicationName' value={this.state.application.ApplicationName || ''}
                                            onChange={this.handleInputChange} />
                                    </td>
                                    <td>
                                        <label><b>Manager Phone</b></label>
                                        <InputText type='text' name='ManagerPhone' value={this.state.application.ManagerPhone || ''}
                                            onChange={this.handleInputChange} />
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <label><b>CA Group</b></label>
                                        <Dropdown name='CagroupNameId' style={{ width: '100%' }} className="ui-column-filter" placeholder="CA Group" value={this.state.application.CagroupNameId}
                                            options={this.state.caGroupNameList} onChange={this.handleInputChange} filter showClear />
                                    </td>
                                    <td>
                                        <label><b>Secondary Contact</b></label>
                                        <InputText type='text' name='SecondaryContact' value={this.state.application.SecondaryContact || ''}
                                            onChange={this.handleInputChange} />
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <label><b>Email Group</b></label>
                                        <InputText type='text' name='EmailGroup' value={this.state.application.EmailGroup || ''}
                                            onChange={this.handleInputChange} />
                                    </td>
                                    <td>
                                        <label><b>Tertiary Contact</b></label>
                                        <InputText type='text' name='TertiaryContact' value={this.state.application.TertiaryContact || ''}
                                            onChange={this.handleInputChange} />
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </Dialog>

                    <Dialog header='Create Application team' footer={this.createFooter}
                        visible={this.state.createApplicationDialogBoxVisible} width='600px' modal={true}
                        onHide={e => this.setState({ createApplicationDialogBoxVisible: false, pageErrorMessage: null })} maximizable={false}>
                        <div>
                            {this.state.pageErrorMessage ? this.showAlertMessage(MessageSeverity.ERROR, this.state.pageErrorMessage) : <></>}
                            <table style={{ width: '600px' }}>
                                <tr>
                                    <td>
                                        <label><b>Enable</b></label>
                                        <InputSwitch checked={this.state.application.IsActive} onChange={this.onStatusSwitchChange}
                                            tooltip={this.state.application.IsActive ? 'YES' : 'NO'} />
                                    </td>
                                    <td>
                                        <label><b>Manager Contact</b></label>
                                        <InputText type='text' name='ManagerContact' value={this.state.application.ManagerContact || ''}
                                            onChange={this.handleInputChange} />
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <label className='required-field'><b>Application Name</b></label>
                                        <InputText type='text' name='ApplicationName' value={this.state.application.ApplicationName || ''}
                                            onChange={this.handleInputChange} />
                                    </td>
                                    <td>
                                        <label><b>Manager Phone</b></label>
                                        <InputText type='text' name='ManagerPhone' value={this.state.application.ManagerPhone || ''}
                                            onChange={this.handleInputChange} />
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <label><b>CA Group</b></label>
                                        <Dropdown name='CagroupNameId' style={{ width: '100%' }} className="ui-column-filter" placeholder="CA Group" value={this.state.application.CagroupNameId}
                                            options={this.state.caGroupNameList} onChange={this.handleInputChange} filter showClear />
                                    </td>
                                    <td>
                                        <label><b>Secondary Contact</b></label>
                                        <InputText type='text' name='SecondaryContact' value={this.state.application.SecondaryContact || ''}
                                            onChange={this.handleInputChange} />
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <label><b>Email Group</b></label>
                                        <InputText type='text' name='EmailGroup' value={this.state.application.EmailGroup || ''}
                                            onChange={this.handleInputChange} />
                                    </td>
                                    <td>
                                        <label><b>Tertiary Contact</b></label>
                                        <InputText type='text' name='TertiaryContact' value={this.state.application.TertiaryContact || ''}
                                            onChange={this.handleInputChange} />
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </Dialog>

                    <Dialog header='Delete Application team' footer={this.confirmDeleteFooter}
                        visible={this.state.confirmDeleteApplicationDialogBoxVisible} width='400px' modal={true}
                        onHide={e => this.setState({ confirmDeleteApplicationDialogBoxVisible: false })} maximizable={false}>
                        <div>
                            Are you sure you want to delete the application team <b>{this.state.application.ApplicationName}</b>?
                        </div>
                    </Dialog>

                    <Dialog header={this.state.application.ApplicationName + ' - Audit Logs'} style={{ width: '40vw' }}
                        visible={this.state.applicationAuditLogDialogBoxVisible} modal={true}
                        onHide={e => this.setState({ applicationAuditLogDialogBoxVisible: false, pageErrorMessage: null })} maximizable={false} closeOnEscape={true}>
                        <div>
                            <DataTable value={this.state.applicationAuditLogs}
                                selectionMode="single"
                                paginator={true}
                                rows={10}
                                rowsPerPageOptions={[10, 20, 50, 100]}
                                filterDisplay="menu"
                                responsiveLayout="scroll"
                                showGridlines removableSort
                                emptyMessage="No Records found."
                                sortField='Timestamp' sortOrder="-1"
                            >
                                <Column field="DisplayTimestamp" header="Timestamp" style={{ textAlign: 'left' }} sortable sortField='Timestamp' />
                                <Column field="ActionType" header="Action" style={{ textAlign: 'left' }} />
                                <Column field="ActionBy" header="Action By" style={{ textAlign: 'left' }} />
                            </DataTable>
                        </div>
                    </Dialog>

                </div>
            </MsalAuthenticationTemplate>
        )
    }
}

const WrappedApplicationComponent = withMsal(ApplicationComponent);
export default withAITracking(reactPlugin, WrappedApplicationComponent);
